/**
 * Horizon adds to cart with fetch() + preventDefault, so UpCart never
 * sees a native form post. This bridge opens UpCart after a successful add
 * and on the custom header cart icon.
 */
(function () {
  var CART_ADD_RE = /\/cart\/(add|update|change)/i;
  var UPCART_WAIT_MS = 8000;
  var UPCART_POLL_MS = 50;
  var pendingOpen = false;

  function whenUpcartReady() {
    if (typeof window.upcartOpenCart === 'function') {
      return Promise.resolve(true);
    }

    return new Promise(function (resolve) {
      var started = Date.now();
      var timer = setInterval(function () {
        if (typeof window.upcartOpenCart === 'function') {
          clearInterval(timer);
          resolve(true);
          return;
        }
        if (Date.now() - started >= UPCART_WAIT_MS) {
          clearInterval(timer);
          resolve(false);
        }
      }, UPCART_POLL_MS);
    });
  }

  function openUpcart() {
    return whenUpcartReady().then(function (ready) {
      if (!ready) return false;
      try {
        window.upcartOpenCart();
        return true;
      } catch (error) {
        return false;
      }
    });
  }

  function notifyUpcartAfterAdd() {
    if (pendingOpen) return;
    pendingOpen = true;

    whenUpcartReady().then(function (ready) {
      pendingOpen = false;
      if (!ready) return;

      try {
        if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      } catch (error) {}

      try {
        if (typeof window.upcartRegisterAddToCart === 'function') window.upcartRegisterAddToCart();
      } catch (error) {}

      try {
        window.upcartOpenCart();
      } catch (error) {}
    });
  }

  function isCartLink(element) {
    if (!(element instanceof Element)) return false;
    if (element.closest('.mrg-header__icon-btn--cart')) return true;
    var link = element.closest('a[href]');
    if (!link) return false;
    var href = link.getAttribute('href') || '';
    return /\/cart\/?(\?|$)/.test(href) && !CART_ADD_RE.test(href);
  }

  function onDocumentClick(event) {
    if (!isCartLink(event.target)) return;
    var link = event.target.closest('a[href]');
    event.preventDefault();
    openUpcart().then(function (opened) {
      if (!opened && link) window.location.href = link.href;
    });
  }

  function onCartLinesUpdate(event) {
    var action = event && event.action;
    if (action && action !== 'add') return;

    var promise = event && event.promise;
    if (!promise || typeof promise.then !== 'function') {
      notifyUpcartAfterAdd();
      return;
    }

    promise
      .then(function (result) {
        if (result && result.detail && result.detail.didError) return;
        notifyUpcartAfterAdd();
      })
      .catch(function () {});
  }

  function patchFetch() {
    if (window.fetch.__mrgUpcartPatched) return;
    var originalFetch = window.fetch.bind(window);

    window.fetch = function (input, init) {
      var url = '';
      if (typeof input === 'string') url = input;
      else if (input && typeof input.url === 'string') url = input.url;

      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      var isCartMutation = method !== 'GET' && CART_ADD_RE.test(url);

      return originalFetch(input, init).then(function (response) {
        if (isCartMutation && response.ok) notifyUpcartAfterAdd();
        return response;
      });
    };

    window.fetch.__mrgUpcartPatched = true;
  }

  window.mrgNotifyUpcartAdd = notifyUpcartAfterAdd;
  window.mrgOpenUpcart = openUpcart;

  patchFetch();
  document.addEventListener('click', onDocumentClick, true);
  document.addEventListener('shopify:cart:lines-update', onCartLinesUpdate);
})();
